// 데이터의 date는 KST 날짜다. 빌드 서버(UTC)에서 미리 그려도 같은 날짜가 나오게 KST로 고정한다.
export const formatHelpDate = (dateString) => {
  const date = new Date(`${dateString}T00:00:00+09:00`);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Asia/Seoul',
  });
};

export const getHelpArticlePath = (id) => `/help/notice/${id}`;

export const getHelpListPath = (tab) => `/help?tab=${tab}`;
